import { EventItem } from "JS/React/Components/EventItem";
import { Theme, InternalStandardProps } from "@mui/material";
import { Layout } from "../Layout";
import { styled } from "@mui/material/styles";
import { AppTypography } from "JS/React/Components/AppTypography";
import clsx from "clsx";
import { useNavigate, useLocation } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useGetWebcast, useGlobalWebcast } from "JS/React/Hooks/Webcast";
import { AppBackdropProgress } from "JS/React/Components/Progress/AppBackdropProgress";
import { messaging } from "JS/Helpers/UserMessaging";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";
import { useMemo } from "react";
import qs from "qs";

export interface WebcastProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

const StyledRoot = styled("div")({});

const StyledTextColor = styled(AppTypography)(({ theme }) => ({
    color: `${theme.palette.primary.main}`,
}));

export const Webcast = (props: WebcastProps) => {
    const { className, ...rest } = props;
    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const { webcasts } = useGlobalWebcast();

    const { loading, isError } = useGetWebcast(false);
    const { queryParams, handleBackNavigation } = useHandler();

    return (
        <Layout>
            <AppHeader
                title={"Webcast"}
                canGoBack
                searchable={false}
                onBackClick={handleBackNavigation}
            />
            <StyledRoot {...rest} className={clsx(className)}>
                {loading && !isError && (
                    <AppBackdropProgress
                        open={true}
                        backdropText={messaging.loader.webcast}
                    />
                )}
                {isError && (
                    <StyledTextColor>
                        There is no scheduled webcast at this time.
                    </StyledTextColor>
                )}
                {!loading &&
                    !isError &&
                    webcasts
                        .map((w) => w)
                        .sort((w1, w2) =>
                            w1.Description.localeCompare(w2.Description),
                        )
                        .sort((w1, w2) => w1.priority - w2.priority)
                        .map((w, idx) => (
                            <EventItem
                                key={`${w.Description}${idx}`}
                                event={{
                                    EventName: w.Description,
                                    EventStartDateAndTime: w.StartDate,
                                    EventEndDateAndTime: w.EndDate,
                                    last_updated_date: w.EndDate,
                                    Tickets: [],
                                }}
                                onEventItemClick={(_, eventName) => {
                                    navigate(
                                        linkProvider.react
                                            .webcast()
                                            .detail(
                                                eventName,
                                                queryParams?.backNav === "true"
                                                    ? true
                                                    : false,
                                            ),
                                    );
                                }}
                            />
                        ))}
            </StyledRoot>
        </Layout>
    );
};

const useHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const { homeStack } = useGlobalNavStack();
    const queryParams = useMemo(() => {
        const parsedQueryString = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });

        const { backNav = "" } = parsedQueryString;

        return {
            backNav: backNav.toString(),
        };
    }, [location?.search]);

    const handleBackNavigation = () => {
        if (queryParams?.backNav === "true") {
            navigate(-1);
        } else {
            if (!homeStack?.isHomeTrack) {
                navigate(linkProvider.react.more().index());
            } else {
                navigate(linkProvider.react.home());
            }
        }
    };
    return { queryParams, handleBackNavigation };
};
